// src/hooks/usePushNotifications.js
import { useEffect } from "react";
import { getToken } from "firebase/messaging";
import { doc, updateDoc } from "firebase/firestore";
import { messaging, db } from "../firebase";

// Firebase Console > Project Settings > Cloud Messaging > Web configuration > Generate key pair
const VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY;

export function usePushNotifications(uid) {
  useEffect(() => {
    if (!uid) return;
    if (!VAPID_KEY) return;
    if (!("Notification" in window)) return;
    if (!("serviceWorker" in navigator)) return;
    if (!messaging) return;
    if (localStorage.getItem("fcmTokenRegistered")) return;

    const register = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        // Use the CRA service worker if registered; skip in dev where no SW is active
        const swReg = await navigator.serviceWorker.getRegistration("/");
        if (!swReg) return;

        const token = await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: swReg,
        });
        if (!token) return;

        await updateDoc(doc(db, "users", uid), { fcmToken: token });
        localStorage.setItem("fcmTokenRegistered", "1");
      } catch (err) {
        console.error("Push notification setup failed:", err);
      }
    };

    register();
  }, [uid]);
}
